import { createDataManager, createUIStateManager, hookEvents } from 'public/Factor/pageAppEngine'

let dataManager, uiStateManager

export const pageApp = {
    start: (data, mapData2UiState, eventHandles, storeData) => {
        dataManager = createDataManager(data, storeData)
        hookEvents(pageApp, eventHandles)
        uiStateManager = createUIStateManager(dataManager, mapData2UiState)
        uiStateManager.start()
    },
    setState: (dataToUpdate, deprecated_value) => {
        uiStateManager.updateData(dataToUpdate, deprecated_value)
    },
    updateData: (dataToUpdate, deprecated_value) => {
        dataManager.updateData(dataToUpdate, deprecated_value)
    },
    getData: () => dataManager.getData()
}